import Cookies from 'js-cookie';

export const formatDateTime = (dateTime) => {
  if (!dateTime) {
    return 'Unknown';
  }
  try {
    const dateObject = new Date(dateTime);
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      hourCycle: 'h11'
    });
    return dateFormatter.format(dateObject);
  } catch {
    // for when date is absent or invalid
    return 'Unknown';
  }
};

export const isNativeApp = (win = window) => {
  return typeof window === 'undefined' ? false : win.__EXPERIENCE_CONTEXT__?.isConsumerApp;
};

export const getUrlParam = (key, win = window) => {
  const searchParams = (typeof win !== 'undefined') ? win?.location?.search : '';
  const urlParams = new URLSearchParams(searchParams);
  return urlParams.get(key);
};

export const getTMXSessionID = (win = window) => {
  const nativeTMXprofileId = getUrlParam('guid', win);
  if (isNativeApp(win) && nativeTMXprofileId) {
    return nativeTMXprofileId;
  }
  return typeof win === 'undefined' ? '' : win?.THD_ACCOUNT_LIB?.TMX?.sessionId;
};

export const activityLogEnabled = () => {
  const FS = 'ENABLE_ACCOUNT_ACTIVITY_LOG';
  return typeof window !== 'undefined' && (Cookies.get(FS)
          || window.__EXPERIENCE_PROPS__?.expConfiguration[FS] === 'true'
          // eslint-disable-next-line eqeqeq
          || window.__EXPERIENCE_PROPS__?.expConfiguration[FS] == '1');
};